/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Filter_DeveloperInputs */

const en_directory_launch_filter_developer = /** @type {(inputs: Directory_Launch_Filter_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const zh_directory_launch_filter_developer = /** @type {(inputs: Directory_Launch_Filter_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发者`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Directory_Launch_Filter_DeveloperInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_filter_developer = /** @type {((inputs?: Directory_Launch_Filter_DeveloperInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Filter_DeveloperInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_filter_developer(inputs)
	return zh_directory_launch_filter_developer(inputs)
});
export { directory_launch_filter_developer as "directory.launch.filter_developer" }